export default "__VITE_ASSET__DFSrMj32__"